import { render, staticRenderFns } from "./HomeMasterKong.vue?vue&type=template&id=2f45e1ba&scoped=true&"
import script from "./HomeMasterKong.vue?vue&type=script&lang=js&"
export * from "./HomeMasterKong.vue?vue&type=script&lang=js&"
import style0 from "./HomeMasterKong.vue?vue&type=style&index=0&id=2f45e1ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f45e1ba",
  null
  
)

export default component.exports